/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Reverse_One_FrameInputs */

const en_shortcut_keys_name_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse 1 Frame`)
};

const fr_shortcut_keys_name_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reculer de 1 image`)
};

const de_shortcut_keys_name_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückwärts 1 Bild`)
};

const it_shortcut_keys_name_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverti 1 fotogramma`)
};

const ru_shortcut_keys_name_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обратная сторона 1 кадр`)
};

const es_shortcut_keys_name_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 fotograma inverso`)
};

const zh_cn2_shortcut_keys_name_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反转 1 帧`)
};

const ja_shortcut_keys_name_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1フレーム逆`)
};

const hi_shortcut_keys_name_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिवर्स 1 फ्रेम`)
};

const pt_pt2_shortcut_keys_name_reverse_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Reverse_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadro Inverso 1`)
};

/**
* | output |
* | --- |
* | "Reverse 1 Frame" |
*
* @param {Shortcut_Keys_Name_Reverse_One_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_reverse_one_frame = /** @type {((inputs?: Shortcut_Keys_Name_Reverse_One_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Reverse_One_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_reverse_one_frame(inputs)
	if (locale === "de") return de_shortcut_keys_name_reverse_one_frame(inputs)
	if (locale === "it") return it_shortcut_keys_name_reverse_one_frame(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_reverse_one_frame(inputs)
	if (locale === "es") return es_shortcut_keys_name_reverse_one_frame(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_reverse_one_frame(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_reverse_one_frame(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_reverse_one_frame(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_reverse_one_frame(inputs)
	return en_shortcut_keys_name_reverse_one_frame(inputs)
});